import { useMemo } from 'react'
import { useControlAccess } from '../../../AccessControl/controlAccess/useControlAccess'
import { useUser } from '../../../fetchData/queries/useUser'
import { PeriodReportData } from '../fetchData/queries/PeriodReportData'

interface UseCommentAccessParams {
  periodReport: PeriodReportData | null
}

export const useCommentAccess = ({ periodReport }: UseCommentAccessParams) => {
  const userScopes = useUser().data?.scopes
  const allowedToComment = useControlAccess(userScopes, ['sheet_write'])

  const canOpenCommentEditor = useMemo(() => {
    return !!periodReport && periodReport.status !== 'Closed'
  }, [periodReport])

  const canEditComment = useMemo(() => {
    return canOpenCommentEditor && allowedToComment
  }, [canOpenCommentEditor, allowedToComment])

  return {
    allowedToComment,
    canOpenCommentEditor,
    canEditComment,
  }
}
